import React, { createContext, useContext, ReactNode } from 'react';
import { Observable } from 'rxjs';
import { ICheckoutExtensions } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { IExtensionGroup } from '@app/pages/checkout-app/checkout-layout/main/components/extension-groups/models/extension-group.models';

interface StoreContextValue {
  extensions$: Observable<ICheckoutExtensions[]>;
  extensionGroups$?: Observable<IExtensionGroup[]>;
}

interface StoreProviderProps {
  children: ReactNode;
  extensions$: Observable<ICheckoutExtensions[]>;
  extensionGroups$?: Observable<IExtensionGroup[]>;
}

const StoreContext = createContext<StoreContextValue | undefined>(undefined);

export const StoreProvider: React.FC<StoreProviderProps> = ({ children, extensions$, extensionGroups$ }) => {
  const contextValue: StoreContextValue = {
    extensions$,
    extensionGroups$,
  };

  return <StoreContext.Provider value={contextValue}>{children}</StoreContext.Provider>;
};

export const useStore = (): StoreContextValue => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};
